/* eslint-disable no-prototype-builtins */
const areTargetValuesEqual = (initialValue = {}, currentValue = {}) => {
  const breakpointKeys = new Set([...Object.keys(initialValue), ...Object.keys(currentValue)]);

  return Array.from(breakpointKeys).every(
    (breakpointKey) => initialValue[breakpointKey] === currentValue[breakpointKey]
  );
};

const getTargetsDifference = (initialTargets = {}, currentTargets = {}) => {
  const targetKeys = new Set([...Object.keys(initialTargets), ...Object.keys(currentTargets)]);

  return Array.from(targetKeys).reduce((diff, targetKey) => {
    const hasInitial = initialTargets.hasOwnProperty(targetKey);
    const hasCurrent = currentTargets.hasOwnProperty(targetKey);

    if (!hasCurrent) {
      return { ...diff, [targetKey]: initialTargets[targetKey] };
    }

    if (
      !hasInitial ||
      !areTargetValuesEqual(initialTargets[targetKey], currentTargets[targetKey])
    ) {
      return { ...diff, [targetKey]: currentTargets[targetKey] };
    }

    return diff;
  }, {});
};

const getStateDifference = (initialState = {}, currentState = {}) => {
  const elementIds = new Set([...Object.keys(initialState), ...Object.keys(currentState)]);

  return Array.from(elementIds).reduce((diff, elementId) => {
    const hasInitial = initialState.hasOwnProperty(elementId);
    const hasCurrent = currentState.hasOwnProperty(elementId);

    if (!hasCurrent) {
      return { ...diff, [elementId]: initialState[elementId] };
    }

    const targetsDiff = hasInitial
      ? getTargetsDifference(initialState[elementId], currentState[elementId])
      : currentState[elementId];

    if (Object.keys(targetsDiff).length > 0) {
      return { ...diff, [elementId]: targetsDiff };
    }

    return diff;
  }, {});
};

export default getStateDifference;
